module.exports = __webpack_public_path__ + "static/media/fly0267.ffe51a69.webp";